import React, { useState } from 'react';
import { Card, Row, Col, Input, Button, Checkbox, Select, DatePicker, InputNumber, Collapse, Space } from 'antd';
import { SearchOutlined, ReloadOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';

const { Option } = Select;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;

export default function SearchFilter({ searchForm, onInputChange, onSubmit, onReset }) {
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  const {
    keyword,
    jobTitles,
    skills,
    yearsOfExperience,
    willingnessToRelocate,
    zipCode,
    searchZipCodeRadius,
    // Advanced filters
    schools,
    degrees,
    companies,
    jobTenure,
    lastActiveMaximumAge,
    resumeUpdatedMinimumAge,
    resumeUpdatedMaximumAge,
    resumePostedFrom,
    resumePostedTo,
  } = searchForm;

  return (
    <Card  bordered={false} style={{ minWidth: '100%' }}>
    <Row justify={'space-between'} gutter={[16, 16]} style={{minWidth: '100%'}}>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Input
          placeholder="Keywords"
          value={keyword}
          onChange={(e) => onInputChange("keyword", e.target.value)}
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Input
          placeholder="Job Titles"
          value={jobTitles}
          onChange={(e) => onInputChange("jobTitles", e.target.value)}
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Input
          placeholder="Skills"
          value={skills}
          onChange={(e) => onInputChange("skills", e.target.value)}
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Years of Experience"
          value={yearsOfExperience}
          onChange={(value) => onInputChange("yearsOfExperience", value)}
        >
          <Option value="0-2">0-2 years</Option>
          <Option value="3-5">3-5 years</Option>
          <Option value="6-10">6-10 years</Option>
          <Option value="10+">10+ years</Option>
        </Select>
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Checkbox
          checked={willingnessToRelocate}
          onChange={(e) => onInputChange("willingnessToRelocate", e.target.checked)}
        >
          Willing to Relocate
        </Checkbox>
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Input.Group compact>
          <Input
            style={{ width: '60%' }}
            placeholder="Zip Code"
            value={zipCode}
            onChange={(e) => onInputChange("zipCode", e.target.value)}
          />
          <InputNumber
            style={{ width: '40%' }}
            placeholder="Radius (miles)"
            value={searchZipCodeRadius}
            onChange={(value) => onInputChange("searchZipCodeRadius", value)}
          />
        </Input.Group>
      </Col>
    </Row>

      <Collapse
        activeKey={showAdvancedFilters ? ['1'] : []}
        onChange={() => setShowAdvancedFilters(!showAdvancedFilters)}
        className="w-full"
      >
        <Panel 
          header={
            <span>
              {showAdvancedFilters ? 'Hide' : 'Show'} Advanced Filters
              {showAdvancedFilters ? <UpOutlined /> : <DownOutlined />}
            </span>
          } 
          key="1"
          className="w-full"
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Input
                placeholder="Schools"
                value={schools}
                onChange={(e) => onInputChange("schools", e.target.value)}
              />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Input
                placeholder="Degrees"
                value={degrees}
                onChange={(e) => onInputChange("degrees", e.target.value)}
              />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Input
                placeholder="Companies"
                value={companies}
                onChange={(e) => onInputChange("companies", e.target.value)}
              />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <InputNumber
                placeholder="Job Tenure (years)"
                value={jobTenure}
                onChange={(value) => onInputChange("jobTenure", value)}
                style={{ width: '100%' }}
              />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <InputNumber
                placeholder="Last Active (minutes)"
                value={lastActiveMaximumAge}
                onChange={(value) => onInputChange("lastActiveMaximumAge", value)}
                style={{ width: '100%' }}
              />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <InputNumber
                placeholder="Resume Updated Min (minutes)"
                value={resumeUpdatedMinimumAge}
                onChange={(value) => onInputChange("resumeUpdatedMinimumAge", value)}
                style={{ width: '100%' }}
              />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <InputNumber
                placeholder="Resume Updated Max (minutes)"
                value={resumeUpdatedMaximumAge}
                onChange={(value) => onInputChange("resumeUpdatedMaximumAge", value)}
                style={{ width: '100%' }}
              />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <RangePicker
                style={{ width: '100%' }}
                placeholder={['Resume Posted From', 'Resume Posted To']}
                value={[resumePostedFrom, resumePostedTo]}
                onChange={(dates) => {
                  onInputChange("resumePostedFrom", dates?.[0]);
                  onInputChange("resumePostedTo", dates?.[1]);
                }}
              />
            </Col>
          </Row>
        </Panel>
      </Collapse>
   
    <Row justify="end" style={{ marginTop: '16px' }}>
      <Space>
        <Button type="primary" icon={<SearchOutlined />} onClick={onSubmit}>
          Search
        </Button>
        <Button icon={<ReloadOutlined />} onClick={onReset}>
          Reset
        </Button>
      </Space>
    </Row>
  </Card>
);
}


